import { searchClient, ALGOLIA_INDICES, ALGOLIA_FILTERS } from '../../../search/algolia/client';

let cachedTrendingItems = null;
let cachedPopularItems = null;
let prefetchPromise = null;

const PRODUCT_CARD_LIMIT = 4;

export async function fetchProductCards({
  indexName = ALGOLIA_INDICES.products,
  query = '',
  hitsPerPage = PRODUCT_CARD_LIMIT,
  facetFilters = ALGOLIA_FILTERS.hiddenProducts,
} = {}) {
  const response = await searchClient.searchSingleIndex({
    indexName,
    searchParams: {
      query,
      hitsPerPage,
      clickAnalytics: Boolean(query),
      facetFilters,
    },
  });

  return {
    ...response,
    productCards: (response.hits || []).slice(0, hitsPerPage).map((hit, indexPosition) => ({
      ...hit,
      __indexName: indexName,
      __queryID: response.queryID || null,
      __position: (Number(response.page) || 0) * hitsPerPage + indexPosition + 1,
    })),
  };
}

export function useSearchData() {
  const prefetchEmptyStateData = () => {
    if (prefetchPromise) return prefetchPromise;

    prefetchPromise = Promise.all([
      searchClient
        .searchSingleIndex({
          indexName: ALGOLIA_INDICES.querySuggestions,
          searchParams: { query: '', hitsPerPage: 5 },
        })
        .then(({ hits }) => {
          cachedTrendingItems = hits;
          return hits;
        }),
      fetchProductCards({
        indexName: ALGOLIA_INDICES.popularProducts,
        query: '',
        hitsPerPage: PRODUCT_CARD_LIMIT,
      })
        .then(({ productCards }) => {
          cachedPopularItems = productCards;
          return cachedPopularItems;
        }),
    ]);

    return prefetchPromise;
  };

  const getTrendingItems = async () => {
    if (cachedTrendingItems) return cachedTrendingItems;
    await prefetchEmptyStateData();
    return cachedTrendingItems || [];
  };

  const getPopularItems = async () => {
    if (cachedPopularItems) return cachedPopularItems;
    await prefetchEmptyStateData();
    return cachedPopularItems || [];
  };

  return { searchClient, prefetchEmptyStateData, getTrendingItems, getPopularItems };
}
